import React from 'react';
import { Download, Edit, Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface SharedBlogsTableProps {
  blogs: any[];
  handleDownloadFile: (blogId: number, fileName: string) => void;
}

const SharedBlogsTable: React.FC<SharedBlogsTableProps> = ({
  blogs,
  handleDownloadFile,
}) => {
  const navigate = useNavigate();

  if (blogs.length === 0) {
    return (
      <div className="border border-gray-200 bg-background rounded-lg p-8">
        <div className="text-center flex flex-col items-center justify-center gap-4">
          <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center">
            <Eye size={24} className="text-gray-400" />
          </div>
          <h3 className="text-lg font-medium text-gray-900">No shared blogs</h3>
          <p className="text-gray-500">
            Blogs shared with you will appear here
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="border border-gray-200 rounded-lg bg-background text-text-primary overflow-x-auto">
      <table className="w-full table-fixed min-w-[640px]">
        <thead>
          <tr className="border-b bg-background-card text-primary">
            <th className="text-left p-4 font-medium md:w-[50%] w-[40%]">
              <div className="flex items-center flex-wrap gap-2">
                Blog Name
                <span className="px-2 py-1 flex items-center text-xs rounded-md bg-secondary text-primary">
                  <Eye size={14} className="mr-1" /> View Only
                </span>
              </div>
            </th>
            <th className="text-left p-4 font-medium md:w-[30%] w-[30%] hidden md:table-cell">
              Date Added<span className="inline-block ml-1">↕</span>
            </th>
            <th className="text-left p-4 font-medium md:w-[20%] w-[30%]">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {blogs.map((blog) => (
            <tr
              key={blog.id}
              className="border-b cursor-pointer hover:bg-gray-50"
              onClick={() => {
                console.log(blog);
                localStorage.setItem('blogContext', JSON.stringify(blog || ''));
                navigate(`/ai-blog-writer/blog`);
              }}
            >
              <td className="p-4">
                <div className="flex items-center gap-2">
                  <span className="truncate">{blog.name}</span>
                </div>
              </td>
              <td className="p-4 hidden md:table-cell">{blog.dateAdded}</td>
              <td className="p-4">
                <div className="flex gap-2">
                  <button
                    className="p-1 text-primary hover:text-primary/80"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDownloadFile(blog.id, blog.name);
                    }}
                    title="Print / Export"
                  >
                    <Download size={18} />
                  </button>
                  <button
                    className="p-1 text-primary hover:text-primary/80"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/ai-blog-writer/blog?id=${blog.id}`);
                    }}
                  >
                    <Edit size={18} />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SharedBlogsTable;
